import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import PrimaryNav from '@/components/PrimaryNav';
import PwaInstallBanner from '@/components/PwaInstallBanner';
import SiteFooter from '@/components/SiteFooter';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Map a pathname to the nav's active key.
const activeFromPath = (pathname) => {
  if (pathname === '/') return 'home';
  if (pathname.startsWith('/stories')) return 'stories';
  if (pathname.startsWith('/offline-spots')) return 'spots';
  // Bookmarks now hangs off the Profile module, so it keeps Profile lit.
  if (pathname.startsWith('/bookmarks') || pathname.startsWith('/profile') || pathname.startsWith('/settings')) return 'profile';
  return null;
};

/**
 * App shell that renders the persistent Pinterest-style nav (left rail on
 * desktop, bottom bar on mobile) around every page except the sign-in flow.
 * Each page keeps its own top header; this only owns the app-level nav.
 */
const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => !cancelled && setUser(res.data))
      .catch(() => !cancelled && setUser(null));
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  // Create opens the Share composer, which lives on the feed. From any page we
  // route home with an intent flag; Discovery reads it and opens the form.
  const handleCreate = () => {
    if (!user) {
      navigate('/login');
      return;
    }
    navigate('/', { state: { openCreate: true } });
  };

  return (
    <div className="min-h-screen md:pl-[72px] pb-20 md:pb-0">
      <PrimaryNav
        user={user}
        active={activeFromPath(location.pathname)}
        onHome={() => navigate('/')}
        onCreate={handleCreate}
        onProfile={() => navigate(user ? '/profile' : '/login')}
      />

      {children}

      <SiteFooter />

      {/* Mobile-web install nudge (once per session, after ~30s dwell). */}
      <PwaInstallBanner />
    </div>
  );
};

export default Layout;
